import type { AppRouteRecordRaw } from '@/router/types'
import { useI18n } from '@/hooks/web/useI18n'
import { LAYOUT, BLANK } from '@/router/constant'

const { t } = useI18n()

const ICCARD_ROUTES: AppRouteRecordRaw[] = [
  {
    path: '/iccard',
    name: 'ICCard',
    component: LAYOUT,
    meta: {
      title: t('router.icManagement'),
      hideBreadcrumb: true,
      hideMenu: false,
      icon: 'creditcard'
    },
    children: [
      {
        path: 'make-card',
        name: 'MakeCard',
        component: BLANK,
        redirect: '/iccard/make-card/index',
        meta: {
          title: t('icCard.makeCard'),
          hideBreadcrumb: true,
          master: true,
          hideMenu: false
        },
        children: [
          {
            path: 'index',
            name: 'MakeCardIndex',
            component: () => import('@/views/icCardManagement/make-card/index.vue'),
            meta: {
              title: t('icCard.makeCard'),
              hideBreadcrumb: true,
              hideMenu: false
            }
          }
        ]
      },
      {
        path: 'card-info',
        name: 'CardInfo',
        component: () => import('@/views/icCardManagement/make-card/card-info.vue'),
        meta: {
          title: t('icCard.makeCard'),
          hideBreadcrumb: true,
          hideMenu: true
        }
      },
      {
        path: 'delay-card',
        name: 'DelayCard',
        component: BLANK,
        redirect: '/iccard/delay-card/index',
        meta: {
          title: t('icCard.delayCard'),
          hideBreadcrumb: true,
          hideMenu: false,
          master: true
        },
        children: [
          {
            path: 'index',
            name: 'DelayCardIndex',
            component: () => import('@/views/icCardManagement/delay-card/index.vue'),
            meta: {
              title: t('icCard.makeCard'),
              hideBreadcrumb: true,
              hideMenu: false
            }
          }
        ]
      },
      {
        path: 'manager-card',
        name: 'ManagerCardList',
        component: BLANK,
        redirect: '/iccard/manager-card/list',
        meta: {
          title: t('icCard.managerCardList'),
          hideBreadcrumb: true,
          hideMenu: false,
          master: true
        },
        children: [
          {
            path: 'list',
            name: 'ManagerCard',
            component: () => import('@/views/icCardManagement/manager-card/index.vue'),
            meta: {
              title: t('icCard.managerCardList'),
              hideBreadcrumb: false,
              hideMenu: false
            }
          },
          {
            path: 'card-replace',
            name: 'ReplaceCard',
            component: () => import('@/views/icCardManagement/make-card/card-replacement.vue'),
            meta: {
              title: t('router.cardReplace'),
              hideBreadcrumb: true,
              hideMenu: false
            }
          },
          {
            path: 'update-card',
            name: 'update-card',
            component: () => import('@/views/icCardManagement/make-card/update-card.vue'),
            meta: {
              title: t('router.updateCard'),
              hideBreadcrumb: true,
              hideMenu: true
            }
          }
        ]
      },

      // 管理员卡读卡详情
      {
        path: 'admin-card-info',
        name: 'AdminCardInfo',
        component: () => import('@/views/icCardManagement/make-card/adminCardInfor.vue'),
        meta: {
          title: t('icCard.makeCard'),
          hideBreadcrumb: true,
          hideMenu: true
        }
      }
    ]
  }
]

export default ICCARD_ROUTES
